
import React, { Component, Fragment } from "react"; 
import {   Link } from 'react-router-dom'; 
import TimeAgo from 'react-timeago';

import { SERVER } from '../../services/api';
 
import { connect } from "react-redux";
// import { getViewSuccess, getCurrentUser } from "../store/actions";
 
  

class ViewSuccess extends Component {
    constructor(props) {
        super(props); 
 
    }

componentWillMount () {


        const { success, history } = this.props;

        if ( typeof success.title == "undefined") {
          history.push('.');
        }
}
 

 
    

 
    render() {
        const { success } = this.props;

        return <> 


 

<div
 
     className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
    <h1 className="h2 text-capitalize">{ success.title || "view success"}</h1>
    <div className="btn-toolbar mb-2 mb-md-0">
      <div className="btn-group mr-2">

      </div>
      <span className="my-auto mr-3 text-muted"><TimeAgo date={success.date } /></span>
      <Link to={ `.` } className="btn btn-sm btn-outline-secondary  ">
       <i className="icofont-box mr-2"></i>
      All Successs
      </Link>
    </div>
  </div> 






      <div className="row"> 

          <div className="col">

            <div className="row">

              <div className="col-sm-12 col-md-4">

                <div className="form">



                  <div className="form-group">
                      <lable>Title</lable>  
                      <p className="form-control mt-2">{success.title}</p> 
                  </div>


                  


                </div>


              </div>

              <div className="col-sm-12 col-md-4">
              <div className="form">

 

                <div className="form-group">
                    <lable>Youtube Key</lable>  
                    <p className="form-control mt-2">{success.youtube}</p> 
                </div>

                </div>

                </div>
              <div className="col-sm-12 col-md-4">
              <div className="form">

 

                <div className="form-group">
                    <lable>User</lable>  
                    <p className="form-control mt-2">{success.user}</p> 
                </div>

                </div>

                </div>




<div className="col-sm-12 ">
<div className="form">


                  <div className="form-group">
                      <lable>Description</lable>  
                      <p className="form-control mt-2" style={{ minHeight: '100px'}}>{success.description}</p> 
                  </div>


              </div>





              </div>

            </div>


            

</div>
</div>

         </>
 
    } 
}




export default connect(store => ({
    auth: store.auth,
    success: store.success,
    error: store.error
}), {   })(ViewSuccess);


